import React from 'react';
import { Navigate, Route, generatePath, useLocation, useParams } from 'react-router-dom';

import config from '@seller-area/config';
import {
  SALES_SIMULATOR_GD_NEW_SIMULATION_PATH,
  SALES_SIMULATOR_GD_PATH,
  SALES_SIMULATOR_GD_RESULT_PATH,
  SALES_SIMULATOR_ML_CONTRACT_REQUEST_PATH,
  SALES_SIMULATOR_ML_LEAD_PATH,
  SALES_SIMULATOR_ML_NEW_SIMULATION_PATH,
  SALES_SIMULATOR_ML_PATH,
} from '@seller-area/routers/constants';

// Redirects from the old sales web paths: mounted at the top of the main router, outside the session.
// The old paths are literals because they are URLs that were already published.

const RedirectKeepingQuery = ({ to }: { to: string }) => {
  const { search } = useLocation();
  return <Navigate replace to={{ pathname: to, search }} />;
};

const RedirectLead = () => {
  const { leadId } = useParams<{ leadId: string }>();
  return (
    <Navigate replace to={leadId ? generatePath(SALES_SIMULATOR_ML_LEAD_PATH, { leadId }) : SALES_SIMULATOR_ML_PATH} />
  );
};

const RedirectGdProposalForm = () => {
  const { search } = useLocation();
  const id = new URLSearchParams(search).get('simulationId');
  return <Navigate replace to={id ? generatePath(SALES_SIMULATOR_GD_RESULT_PATH, { id }) : SALES_SIMULATOR_GD_PATH} />;
};

const KEEPING_QUERY: [string, string][] = [
  ['/historico', SALES_SIMULATOR_ML_PATH],
  ['/simulador-de-cenarios', SALES_SIMULATOR_ML_NEW_SIMULATION_PATH],
  ['/simulador-de-cenarios/calculadora', SALES_SIMULATOR_ML_NEW_SIMULATION_PATH],
  ['/geracao-distribuida', SALES_SIMULATOR_GD_PATH],
  ['/geracao-distribuida/novo', SALES_SIMULATOR_GD_NEW_SIMULATION_PATH],
];

const CONTRACT_KEEPING_QUERY: [string, string] = ['/contrato', SALES_SIMULATOR_ML_CONTRACT_REQUEST_PATH];

const keepingQueryRedirects = (): [string, string][] =>
  config.SELLER_CONTRACTS_ENABLED ? [...KEEPING_QUERY, CONTRACT_KEEPING_QUERY] : KEEPING_QUERY;

export const legacyRedirectRoutes = (): JSX.Element[] => [
  ...keepingQueryRedirects().map(([from, to]) => (
    <Route key={from} path={from} element={<RedirectKeepingQuery to={to} />} />
  )),
  <Route key="/simulacoes-por-lead/:leadId" path="/simulacoes-por-lead/:leadId" element={<RedirectLead />} />,
  <Route
    key="/geracao-distribuida/proposta-form"
    path="/geracao-distribuida/proposta-form"
    element={<RedirectGdProposalForm />}
  />,
];
